import {Component, Inject} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SnackbarService} from '../../../services/snackbar.service';
import {SpinnerService} from '../../../services/spinner.service';
import {
  DocumControllerService,
} from 'api-rest';
import {DatePipe} from '@angular/common';
import {DownloadService} from '../../../services/download.service';


@Component({
  selector: 'comunications-comunication-response-dialog',
  templateUrl: './comunication-response-dialog.component.html',
  styleUrls: ['./comunication-response-dialog.component.scss'],
})
export class ComunicationResponseDialogComponent {

  comunicacion: any;
  datosForm!: FormGroup;

  displayUsuario:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ComunicationResponseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService,
    private datePipe: DatePipe,
    private documControllerSrv: DocumControllerService,
    private downloadSrv: DownloadService,
  ) {
    this.comunicacion = this.data.comunicacion;
    this.displayUsuario = this.data.displayUsuario;

    this.datosForm = this.formBuilder.group({
      fechaAlta: [{ value: null, disabled: true }],
      estado: [{ value: null, disabled: true }],
      comentarios: [{ value: null, disabled: true }],
      creadoPor: [{ value: null, disabled: true }],
    });

  }
  ngOnInit(): void {
    this.cargarComunicacion();
  }


  cargarComunicacion() {
    this.datosForm.patchValue({
        fechaAlta: this.datePipe.transform(this.comunicacion?.fechaAlta, 'dd/MM/yyyy') ,
        estado: this.comunicacion?.estado?.descripcion,
        comentarios: this.comunicacion?.comentarios,
        creadoPor: this.comunicacion?.creadoPor,
      }
    );
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  descargar(element: any) {
    this.spinnerSrv.loadingShow();
    this.documControllerSrv.downloadDoc(element.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadSrv.downloadBlob(response, element.nombre);
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al descargar el documento',
          'error'
        );
      },
    });
  }



}
